[
  {
    "id": "GET-B8-L301-001",
    "module": "Getalbegrip",
    "difficulty": 301,
    "question": "Reken uit: 15% van 200",
    "options": [
      "30",
      "20",
      "15",
      "40"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "procenten",
    "subSkill": "procenten",
    "familyId": "GET-PROC-BEREKENEN",
    "explanation": "10% is 20. 5% is 10. Samen is dat 30.",
    "distractorExplanations": {
      "1": "20 is 10% van 200. Maar de vraag is 15%, dus je moet er nog 5% (= 10) bij optellen.",
      "2": "Je hebt het getal 15 overgenomen uit de vraag. Maar 15% van 200 is niet 15. Reken: 10% = 20, 5% = 10, samen 30.",
      "3": "40 is 20% van 200. Maar de vraag is 15%, dat is iets minder."
    }
  },
  {
    "id": "GET-B8-L301-002",
    "module": "Getalbegrip",
    "difficulty": 301,
    "question": "Maak de reeks af: 2, 4, 8, 16, ...",
    "options": [
      "32",
      "24",
      "20",
      "30"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "getallenleer",
    "subSkill": "reeksen",
    "familyId": "GET-REEKS",
    "explanation": "Het getal verdubbelt steeds. 16 + 16 = 32.",
    "distractorExplanations": {
      "1": "Je telde er 8 bij op (16 + 8 = 24). Maar het patroon is verdubbelen, niet steeds 8 erbij.",
      "2": "Je telde er 4 bij op (16 + 4 = 20). Kijk goed: 2→4 is ×2, 4→8 is ×2, 8→16 is ×2. Dus 16 × 2 = 32.",
      "3": "30 past niet in het patroon. Elk getal wordt verdubbeld: 2, 4, 8, 16, 32."
    }
  },
  {
    "id": "GET-B8-L301-003",
    "module": "Getalbegrip",
    "difficulty": 301,
    "question": "Welk getal is deelbaar door 3?",
    "options": [
      "123",
      "124",
      "125",
      "122"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "getallenleer",
    "subSkill": "deelbaarheid",
    "familyId": "GET-DEELBAARHEID",
    "explanation": "Tel de cijfers op: 1 + 2 + 3 = 6. 6 is deelbaar door 3, dus 123 ook.",
    "distractorExplanations": {
      "1": "1+2+4=7. Niet deelbaar door 3.",
      "2": "Eindigt op 5, deelbaar door 5.",
      "3": "1+2+2=5. Niet deelbaar door 3."
    }
  },
  {
    "id": "GET-B8-L301-004",
    "module": "Getalbegrip",
    "difficulty": 301,
    "question": "Reken uit: 0,2 $\\times$ 0,3 =",
    "options": [
      "0,06",
      "0,6",
      "0,5",
      "0,05"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "kommagetallen",
    "subSkill": "kommagetallen",
    "familyId": "GET-KEER-KOMMA",
    "explanation": "2 $\\times$ 3 = 6. Er zijn in totaal 2 cijfers achter de komma. Dus 0,06.",
    "distractorExplanations": {
      "1": "Je plaatste maar 1 cijfer achter de komma. Maar 0,2 heeft 1 decimaal en 0,3 ook. Samen 2 decimalen, dus 0,06.",
      "2": "Je telde de getallen op (0,2 + 0,3 = 0,5) in plaats van te vermenigvuldigen.",
      "3": "Je plaatste de 6 verkeerd. Tel het totaal aantal decimalen: 1 + 1 = 2. Dus twee cijfers achter de komma: 0,06."
    }
  },
  {
    "id": "GET-B8-L301-005",
    "module": "Getalbegrip",
    "difficulty": 301,
    "question": "Wat is $\\frac{3}{5}$ in procenten?",
    "options": [
      "60%",
      "30%",
      "50%",
      "35%"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "procenten",
    "subSkill": "procenten",
    "familyId": "GET-PROC-BEREKENEN",
    "explanation": "$\\frac{1}{5}$ is 20%. $\\frac{3}{5}$ is 3 $\\times$ 20% = 60%.",
    "distractorExplanations": {
      "1": "Je hebt de 3 en 0 gecombineerd.",
      "2": "Dat is een half.",
      "3": "Je hebt de 3 en 5 gecombineerd."
    }
  }
]